import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg'; // Sorting icon
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import editPenImg from '../../assets/images/CustomerManagement/edit-pen-img.svg';
import SbStatusDropdown from '../Buttons/SbStatusDropdown';
import SbCancelBtn, { SbAddBtn } from '../Buttons/Buttons';
import calendar from '../../assets/images/Dashboard/calendar-icon.svg';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Form, Row } from 'react-bootstrap';
import AddLeave from './AddLeave';
import { useNavigate } from 'react-router-dom';
import PaginationComponent from '../PaginationComponent';
import { loadApprovedLeaveData, loadLeaveBalanceData, loadPendingLeaveData, loadSingleLeaveBalanceData } from '../../redux/action';
import { useDispatch, useSelector } from 'react-redux';
import noDataFound from '../../assets/images/no-data-found.svg'
import Skeleton from 'react-loading-skeleton';
import { formatDate } from '../DateTimeUtils';

// Table columns
const columns = [
    { id: 'LeaveID', label: 'ID', align: 'left', minWidth: '80px' },
    { id: 'UserName', label: 'NAME', align: 'left', minWidth: '150px' },
    { id: 'EmailID', label: 'Email.ID', align: 'left', minWidth: '200px' },
    { id: 'Phone', label: 'CONTACT', align: 'left', minWidth: '100px' },
    { id: 'LeaveTypeName', label: 'LEAVE TYPE', align: 'left', minWidth: '150px' },
    { id: 'DepartmentName', label: 'DEPARTMENT', align: 'left', minWidth: '150px' },
    { id: 'ReportingTo', label: 'REPORTING TO', align: 'left', minWidth: '150px' },
    { id: 'AppliedOn', label: 'APPLIED ON', align: 'left', minWidth: '180px' },
    { id: 'LeaveDuration', label: 'LEAVE DURATION', align: 'left', minWidth: '180px' },
    { id: 'Reason', label: 'REASON', align: 'left', minWidth: '200px' },
    { id: 'Status', label: 'STATUS', align: 'left', minWidth: '130px' },
];

const ApprovedLeaveDetails = () => {
    const navigate = useNavigate(); // Initialize navigate
    const dispatch = useDispatch();
    const { approvedLeaveData } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);
    const { singleLeaveBalanceData } = useSelector((state) => state.data);

    const [openAddLeave, setAddLeave] = useState(false);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const currentYear = new Date().getFullYear();
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();

    // Pagination state
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page
    const [paginatedData, setPaginatedData] = useState([]);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [leaveBalanceUserId, setleaveBalanceUserId] = useState('');
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(true);

    const approvedLeave = () => {
        dispatch(loadApprovedLeaveData(setLoading, rowsPerPage, page + 1, searchQuery, fromDate, toDate));
    }

    useEffect(() => {
        approvedLeave();
    }, [rowsPerPage, page + 1, searchQuery, fromDate, toDate]);

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (order) => {
        setOrder(order);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const handleActionClick = (event, customer) => {
        setSelectedCustomer(customer);
        setActionAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setActionAnchorEl(false);
    };

    const handleAddLeave = () => {
        setAddLeave(true);
    };

    const handleCloseAddLeave = () => {
        setAddLeave(false);
        setleaveBalanceUserId('');
    };

    const handleEditLeave = (balanceId, startDate, endDate) => {
        setAddLeave(true);
        if (balanceId && startDate && endDate) {
            dispatch(loadSingleLeaveBalanceData(balanceId, startDate, endDate));
            setleaveBalanceUserId(balanceId);
        } else {
            setleaveBalanceUserId("");
        }
    };

    // const getLeaveBalanceData = () => {
    //     dispatch(loadLeaveBalanceData(setLoading, fromDate, toDate));
    // }

    // useEffect(() => {
    //     getLeaveBalanceData();
    // }, [fromDate, toDate]);

    // const sortedData = React.useMemo(() => {
    //     const stabilizedData = approvedLeaveData?.map((el, index) => [el, index]);
    //     stabilizedData.sort((a, b) => {
    //         const orderModifier = order === 'asc' ? 1 : -1;
    //         if (a[0][orderBy] < b[0][orderBy]) {
    //             return -1 * orderModifier;
    //         }
    //         if (a[0][orderBy] > b[0][orderBy]) {
    //             return 1 * orderModifier;
    //         }
    //         return a[1] - b[1];
    //     });
    //     return stabilizedData.map((el) => el[0]);
    // }, [approvedLeaveData, order, orderBy]);

    // Pagination logic
    // Pagination logic
    useEffect(() => {
        if (!approvedLeaveData || approvedLeaveData.length === 0) {
            console.warn("⚠️ No Leave Data Found!");
            setPaginatedData([]);
            return;
        }

        // Sort data based on order & orderBy
        const sorted = [...approvedLeaveData].sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            return a[orderBy] < b[orderBy] ? -1 * orderModifier : 1 * orderModifier;
        });

        // Calculate pagination
        const maxPage = Math.ceil(sorted.length / rowsPerPage);
        const newPage = Math.min(page, maxPage - 1); // Prevents out-of-range pages

        const start = newPage * rowsPerPage;
        const end = start + rowsPerPage;
        const paginated = sorted.slice(start, end);

        setPaginatedData(paginated);
    }, [approvedLeaveData, order, orderBy, page, rowsPerPage]);

    const handlePageChange = (newPage) => {
        setPage(newPage - 1); // Handle 1-based to 0-based page index for slicing
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0); // Reset to the first page when rows per page changes
    };

    const handleNameClick = (id) => {
        navigate(`/leaveDetails`); // Navigate to leaveDetails with the specific ID
    };

    const handleClearFilters = () => {
        setSearchText("");
        setSearchQuery("");
        setFromDate(null);
        setToDate(null);
        approvedLeave();
    }

    return (
        <div className="customer-management-container">
            <div className="customermanagement-content">
                <Row className='customermanagement-btns-container'>
                    <Col md={3} className='customermanagement-backbtn-div'>
                        <span>Approved Leave Details</span>
                    </Col>
                    <Col md={9} className='customermanagement-search-filter'>
                        <div className='customermanagement-search'>
                            <Form.Control
                                type="search"
                                placeholder='Search'
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <img src={searchIcon} alt="Search" onClick={handleSearchClick} />
                        </div>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                id="date-range-picker"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                // selectsRange
                                dropdownMode="select"
                                placeholderText='From'
                                maxDate={new Date()}
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                        <div className='calendar-container'>
                            <DatePicker
                                className="select from-date"
                                id="date-range-picker"
                                dateFormat="dd/MM/yyyy"
                                showMonthDropdown
                                showYearDropdown
                                // selectsRange
                                dropdownMode="select"
                                placeholderText='To'
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                maxDate={new Date()}
                            />
                            <img src={calendar} alt="Calendar" />
                        </div>
                        {/* <SbAddBtn btnName="Add Leaves" onClickEffect={handleAddLeave} /> */}
                        <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                    </Col>
                </Row>
                <TableContainer component={Paper} sx={{ maxHeight: 440 }} className='table-container'>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }} className='table-header-div'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {column.label}
                                            {column.sortable !== false && (
                                                <IconButton
                                                    size="small"
                                                    onClick={(event) => handleRequestSort(event, column.id)}
                                                >
                                                    <img src={SortIcon} alt="Sort" />
                                                </IconButton>
                                            )}
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                loading ? (
                                    [...Array(rowsPerPage)].map((_, index) => (
                                        <TableRow key={index}>
                                            {columns.map((column) => (
                                                <TableCell key={column.id} align={column.align}>
                                                    <Skeleton height={40} />
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))
                                ) : paginatedData.length === 0 ? (
                                    // Display "No Data Found" row if no data is present in the paginated data
                                    <TableRow>
                                        <TableCell colSpan={columns.length} align="center">
                                            <img src={noDataFound} alt="" style={{ height: "250px", width: "280px" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedData.map((customer) => (
                                        <TableRow key={customer.id} >
                                            {columns.map((column) => (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.id === 'Status' ? (
                                                        <span>
                                                            <SbStatusDropdown customer={customer} />
                                                        </span>
                                                    ) : (
                                                        column.id === 'name' ? (
                                                            <span style={{ cursor: "pointer" }}
                                                            // onClick={() => handleRowClick(customer)}
                                                            >
                                                                {customer[column.id]}
                                                            </span>
                                                        ) : column.id === 'AppliedOn' ? (
                                                            formatDate(customer[column.id]) // Format the Date field
                                                        ) : (
                                                            customer[column.id]
                                                        )
                                                    )}
                                                </TableCell>

                                            ))}
                                        </TableRow>
                                    )))}
                        </TableBody>
                    </Table>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                    >
                        <MenuItem onClick={() => handleSortOrderChange('asc')}>
                            <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                            Ascending to Descending
                        </MenuItem>
                        <MenuItem onClick={() => handleSortOrderChange('desc')}>
                            <img src={descToAsc} alt="" />&nbsp;&nbsp;
                            Descending to Ascending
                        </MenuItem>
                    </Menu>
                </TableContainer>
                {/* Use PaginationComponent */}
                <PaginationComponent
                    totalItems={totalDataCount}
                    itemsPerPage={rowsPerPage}
                    onPageChange={handlePageChange}
                    onRowsPerPageChange={handleRowsPerPageChange}
                />
            </div>
            {/* {openAddLeave && <AddLeave openAddLeave={openAddLeave} handleCloseAddLeave={handleCloseAddLeave} leaveBalanceUserId={leaveBalanceUserId} singleLeaveBalanceData={singleLeaveBalanceData} getLeaveBalanceData={getLeaveBalanceData} />} */}
        </div>
    );
};

export default ApprovedLeaveDetails;
